import { useEffect, useRef } from 'react';
import {
    BoundedContent,
    Button,
    EmptyState,
    EmptyStateActions,
    EmptyStateIllustration,
    EmptyStateTitle,
    FlexBox,
    H4,
    Spinner,
} from '@vp/swan';
import { useIdentityContext } from '@99designs/design-services-common';
import { DS_REQUEST_BRIEF_CREATE_URL, __, __url } from '@99designs/i18n';
import { useHandleSubmit } from './useHandleSubmit';

interface SubmitProps {
    briefId: string;
    locale: string;
    willSkipCart: boolean;
}

export function Submit({ briefId, locale, willSkipCart }: SubmitProps) {
    const hasRun = useRef(false);
    const { accessToken, shopperId } = useIdentityContext();
    const { handleSubmit, state, loadingCopy, currentUrl, mpvId } = useHandleSubmit({
        briefId,
        locale,
        accessToken,
        shopperId,
        willSkipCart,
    });

    const isDuplicateBriefPurchaseAttempt = state === 'duplicate';

    const onViewProject = () => {
        window.location.replace(currentUrl);
    };

    const onStartNewBrief = () => {
        window.location.replace(`${DS_REQUEST_BRIEF_CREATE_URL}?mpvId=${mpvId}`);
    };

    useEffect(() => {
        if (!hasRun.current) {
            handleSubmit();
            hasRun.current = true;
        }
    }, [handleSubmit]);

    return (
        <BoundedContent p={7}>
            {isDuplicateBriefPurchaseAttempt ? (
                <EmptyState>
                    <EmptyStateIllustration illustrationType="error" />
                    <EmptyStateTitle>
                        {__('This design brief has already been purchased')}
                    </EmptyStateTitle>

                    <EmptyStateActions pt={4}>
                        <Button skin="secondary" onClick={onViewProject}>
                            {__('View project')}
                        </Button>
                        <Button skin="primary" onClick={onStartNewBrief}>
                            {__('Start new brief')}
                        </Button>
                    </EmptyStateActions>
                </EmptyState>
            ) : (
                <>
                    <FlexBox justifyContent={'center'} m={8}>
                        <Spinner size="super" accessibleText={__('Redirecting to the cart...')} />
                    </FlexBox>
                    <H4 p={'2'} textAlign={'center'}>
                        {loadingCopy}
                    </H4>
                </>
            )}
        </BoundedContent>
    );
}
